import * as actionTypes from 'modules/steps/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const open = () => true;
const close = () => initialState;

export default createReducer(initialState, {
  [actionTypes.OPEN_FOLLOW_UP_CONFIG_MODAL]: open,
  [actionTypes.CLOSE_FOLLOW_UP_CONFIG_MODAL]: close,
  [actionTypes.SAVE_FOLLOW_UP_CONFIG_SUCCESS]: close,
});
